import PageHandler from './pageHandler';
import Gdrp from './Utils/Gdrp';

function App() {
  return (
    <>
      <Gdrp />
      <PageHandler />
    </>
  );
}

export default App;
